import AdminDevicesList from "./AdminDevicesList";

function LinkedDevicesList () {

    return (
        <AdminDevicesList
            title='dashboard.sbiDevice'
            subTitle='devicesList.linkedDevicesList'
            isLinkedDevicesList={true}
        />
    );
}
export default LinkedDevicesList;